import { combineReducers } from "redux";

// Front
import Layout from "./layout/reducer";

// Authentication
import Login from "./auth/login/reducer";
import Account from "./auth/register/reducer";
import ForgetPassword from "./auth/forgetpwd/reducer";
import Profile from "./auth/profile/reducer";
import Config from "./config/reducer";
import ContactList from "./contacts-lists/reducer";
import User from "./account/reducer";
import BulkList from "./bulk-lists/reducer";
import Scheduled from "./scheduled/reducer";

//Dashboard 
import Dashboard from "./dashboard/reducer";
import DashboardBlog from "./dashboard-blog/reducer";

const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  Account,
  Config,
  ForgetPassword,
  Profile,
  Dashboard,
  DashboardBlog,
  ContactList,
  User,
  BulkList,
  Scheduled,
});

export default rootReducer;
